import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Division } from '@models/profileConfiguration/model';

export type DivisionState = EntityState<Division, string>

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'Division' })
export class DivisionStore extends EntityStore<DivisionState> {
  constructor() {
    super();
  }
}
